import {Button} from "../../../../index";
import React from "react";
import {useViewerStore} from "../../../../../store/store";

interface RestrictFinalisePopupProps {
    certification_status: string;
}

const LockedDesignValidation = (props: RestrictFinalisePopupProps) => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>This design has been {props.certification_status}. <br/>Therefore, the design is locked, and your changes
                cannot be saved.</p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <Button
                    id={"spinAllConfirmBtn"}
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize"
                    onClick={cancelFinalize}
                >
                    Confirm
                </Button>
            </div>
        </>
    )
}

export default LockedDesignValidation;